import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function ImpressumPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-947">
      <Navbar data-id="element-948" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto w-full" data-id="element-949">
        <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-10 tracking-tight" data-id="element-950">
          Impressum
        </h1>

        <div className="prose prose-slate max-w-none space-y-8" data-id="element-951">
          <section data-id="element-952">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-953">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-954">
              <strong data-id="element-955">2N Kurse GbR Dres. Schwenk, Striegel, Herzog</strong>
              <br data-id="element-956" />
              Ludwigsplatz 1a
              <br data-id="element-957" />
              90403 Nürnberg
            </p>
          </section>

          <section data-id="element-958">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-959">Kontakt</h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-960">
              Telefon: 0911 – 56836360
              <br data-id="element-961" />
              E-Mail: info@2n-fortbildung.de
            </p>
          </section>

          <section data-id="element-962">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-963">
              Vertreten durch
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-964">
              Dr. Thomas Schwenk
              <br data-id="element-965" />
              Dr. Markus Striegel
              <br data-id="element-966" />
              Dr. Johanna Herzog
            </p>
          </section>
        </div>
      </main>
      <Footer data-id="element-967" />
    </div>;
}